import { render, staticRenderFns } from "./FollowupsTable.vue?vue&type=template&id=1dd8ba4b&scoped=true"
import script from "./FollowupsTable.vue?vue&type=script&lang=js"
export * from "./FollowupsTable.vue?vue&type=script&lang=js"
import style0 from "./FollowupsTable.vue?vue&type=style&index=0&id=1dd8ba4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8ba4b",
  null
  
)

export default component.exports